import authenticationService from 'framework/services/authenticationService';
import Framework from 'framework';
import Cookies from 'cookies-js';
import constants from 'lib/constants';
import urlUtils from 'lib/url-utils';
import authUtils from 'lib/auth-utils';
import localStorage from 'lib/local-storage';
import _ from 'ext:lodash';

let usernameLength = '140';
let loginForm = '#login-form';
let loginClass = '.login-panel';
let loginBtn = '#login-btn';
let loginUsername = '#account-username';
let loginPassword = '#account-password';
let showPassword = '#show-password';
let loginFormGroupUsername = '.login-username-group';
let loginFormGroupPassword = '.login-password-group';
let loginLoading = '.login-loading';
let loginErrorContainer = '.login-error';
let focusValidationActive = false;
//error messages
let requiredMessage = 'This field is required.';
let usernnameLengthMessage = 'This field only allows ' + usernameLength + ' characters.';
let incorrectMessage = 'Sorry, either your username, email, member number, or password didn\'t match what we have on file. Please try again';
let attemptsMessage = 'Too many attempts, your account has been locked.';
let duplicateEmailMessage = 'Sorry, your email is associated with more than one account. Please login with your username or member #.';
let activateAccountMessage = 'Your account has not yet been fully activated. <a href="/account/resend-account-activation-link.html">Click here</a> to resend your activation link. You will be asked to enter your username and password again to verify your identity.';
// if account links are available, append forgot username/password links
if(typeof Framework.global.lt.globalPageDrivers.account !== 'undefined') {
	incorrectMessage += ', <a href="' + Framework.global.lt.globalPageDrivers.account.forgotUsername + '">retrieve your username</a>, or <a href="' + Framework.global.lt.globalPageDrivers.account.forgotPassword + '">reset your password</a>.';
	attemptsMessage += ' Please <a href="' + Framework.global.lt.globalPageDrivers.account.forgotPassword + '">reset your password</a> or <a href="' + Framework.global.lt.globalPageDrivers.account.forgotUsername + '">retrieve your username</a>.';
	duplicateEmailMessage += ' Don\'t know your username? <a href="' + Framework.global.lt.globalPageDrivers.account.forgotUsername + '">Retrieve your username here</a>.';
	activateAccountMessage = 'Your account has not yet been fully activated. <a href="' + Framework.global.lt.globalPageDrivers.account.resendAccountActivationEmail + '">Click here</a> to resend your activation link. You will be asked to enter your username and password again to verify your identity.';
}else{
	incorrectMessage += '.';
}
let validationMessage = 'Please enter a username and password.';
let timeoutMessage = 'Sorry, the login services are not available. Please try to log in later.';
let generalMessage = 'Sorry, there was a problem logging you in. Please try again later.';
let privateBrowsing = 'It looks like you\'re browsing privately. In order to ensure a fully functional web experience, please consider exiting private browsing mode.';

// analytics tracking variables
const loginFormType = 'account';
const loginFormName = 'login';
const loginFormLeadType = '';

function createSsoCookie(sso) {
	// update the time the cookie was last touched
	if(sso != null) {
		Cookies.set(constants.cookieSsoId, sso, {expires: constants.cookieSsoExpires});
		Cookies.set(constants.cookieSsoCreated, Date.now(), {expires: constants.cookieSsoExpires});
	}
}

function createLTAuthenticationCookie(token) {
	if(token != null) {
		if(authUtils.isFeatureFlagEnabled(constants.domainCookiesFeatureFlagId)) {
			Cookies.set(constants.cookieLtAuthentication, token, {expires: constants.cookieSsoExpires, domain: constants.ltDomainName});
		}else {
			Cookies.set(constants.cookieLtAuthentication, token, {expires: '08/20/2021', domain: constants.ltDomainName});
			Cookies.set(constants.cookieLtAuthentication, token, {expires: constants.cookieSsoExpires});
		}
	}
}

function getResourceUrl() {
	var resourceParam = urlUtils.getUrlParameter('resource');

	if(resourceParam) {
		return resourceParam;
	}else if(Cookies.get(constants.cookieLastVisited)){
		return Cookies.get(constants.cookieLastVisited);
	}else{
		// return to the root of the site to allow for the site to handle what to do
		return '/';
	}
}

function redirectUser(sso) {
	// determine if resource parameter is present
	var resource = getResourceUrl();
	// is the resource url onsite
	if(typeof resource !== 'undefined' && resource.length > 0) {
        var decodedResource = decodeURIComponent(resource);
		if(!decodedResource.startsWith('/')) {
			//when resource is not a relative URL post user to partner logic
			$('#partner-form input[name=sso]').val(sso);
			$('#partner-form input[name=id]').val(resource);
			$('#partner-form').submit();
		}else if(decodedResource.startsWith('/bin/lt')) {
			Framework.global.window.location.href = decodedResource;
		}else{
			// break the url into parts and decode the path
			var urlParts = decodedResource.split('?');
			var redirect = urlParts[0];
			if(urlParts.length > 1 && urlParts[1]) {
                // removing "ct" param from resource to avoid redirect loop, considering that Customer Token was invalid
                var paramString = removeRequestParam(urlParts[1], 'ct');
                if(paramString) {
                    redirect += '?' + paramString;
                }
			}
			if(redirect.indexOf('account/forgot-password') >= 0 || redirect.indexOf('account/forgot-username') >= 0){
				redirect = '/account.html';
			}
			Framework.global.window.location.href = redirect;
		}
	}
}

function showSpinner() {
	if(!$(loginLoading).hasClass('in')) {
		$(loginLoading).addClass('in');
	}
}

function hideSpinner() {
	$(loginLoading).removeClass('in');
}

function showErrorMessage(message) {
	if(!message || (typeof message !== 'string')){
		message = generalMessage;
	}
	$(loginErrorContainer).html(message);
	$(loginErrorContainer).collapse('show');
	hideSpinner();
}

function hideErrorMessage() {
	$(loginErrorContainer).removeClass('in');
	$(loginErrorContainer).html('');
}

function showFieldErrorMessage(field, message) {
	if(!$(field).hasClass('has-danger')) {
		$(field).addClass('has-danger');
	}
	if(!$(field).find('input').hasClass('form-control-danger')) {
		$(field).find('input').addClass('form-control-danger');
	}
	$(field).find('span.label-help').html(message);
	$(field).find('span.label-help').collapse('show');
}

function hideFieldErrorMessage(field) {
	$(field).removeClass('has-danger');
	$(field).find('input').removeClass('form-control-danger');
	$(field).find('span.label-help').collapse('hide');
	$(field).find('span.label-help').html('');
}

function validateUsername(username) {
	var success = true;
	if(!username) {
		showFieldErrorMessage(loginFormGroupUsername, requiredMessage);
		success = false;
	}else if(username && username.length > usernameLength) {
		showFieldErrorMessage(loginFormGroupUsername, usernnameLengthMessage);
		success = false;
	}else{
		hideFieldErrorMessage(loginFormGroupUsername);
	}
	return success;
}

function validatePassword(password) {
	var success = true;

	if(!password) {
		showFieldErrorMessage(loginFormGroupPassword, requiredMessage);
		success = false;
	}else{
		hideFieldErrorMessage(loginFormGroupPassword);
	}

	return success;
}

function validateForm(username, password) {
	var valid = validateUsername(username);
	valid = validatePassword(password) && valid;

	// setup listen to watch for validation check on fields
	if(!valid && !focusValidationActive) {
		$(loginUsername).change(function() {
			validateUsername($.trim($(loginUsername).val()));
		});
		$(loginPassword).change(function() {
			validatePassword($.trim($(loginPassword).val()));
		});
		focusValidationActive = true;
	}
	return valid;
}

function handleAuthRequest(e) {
	// clear out the message to the user
	hideErrorMessage();

	// reset the show password button
	$(showPassword).prop('checked', false).trigger('change');

	var username = $.trim($(loginUsername).val());
	var password = $.trim($(loginPassword).val());
	// validate that the inputs have proper values
	if(validateForm(username, password)) {
		// show that the login page is working.
		showSpinner();
		// remove existing login token and sso from users cookies
		authUtils.invalidateSessions();
		// remove existing information from enterprise framework
		window.ef.sessionService.invalidateSession();

		// call service to authenticate
		authenticationService.api.authenticate(username, password).then(
			//Success - trigger change in data
			(data)=> {
				authUtils.setCorrectSsoIdProp(data);
				// clear the password after calling service
				$(loginPassword).val('');
				if(data.message === 'Success') {
					createLTAuthenticationCookie(data.token);
					// update the time the cookie was last touched
					createSsoCookie(data.ssoid);
					window.ef.analyticsService.fireFormSucceededEvent(loginFormType, loginFormName, loginFormLeadType);
					redirectUser(data.ssoid);
				}else if(data.message === 'Password needs to be changed.') {
					if(typeof data.ssoid !== 'undefined') {
						createLTAuthenticationCookie(data.token);
						// update the time the cookie was last touched
						createSsoCookie(data.ssoid);
						redirectUser(data.ssoid);
					} else{
                        window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, data.message);
						showErrorMessage(data.message);
					}
				}else if(data.status === '-201' || data.message === 'Invalid username or password') {
                    window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, incorrectMessage);
					showErrorMessage(incorrectMessage);
				}else if(data.status === '-207') {
                    window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, attemptsMessage);
					showErrorMessage(attemptsMessage);
				}else if(data.status === '-208') {
                    window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, activateAccountMessage);
					showErrorMessage(activateAccountMessage);
				}else if(data.status === '-209') {
                    window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, duplicateEmailMessage);
					showErrorMessage(duplicateEmailMessage);
				// check for statusCode as this can be returned by auth V2 api
				}else if(data.statusCode === 500) {
                    window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, generalMessage);
					showErrorMessage(generalMessage);
				}else{
                    window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, validationMessage);
					showErrorMessage(validationMessage);
				}
			},
			//Error - log error
			(message)=> {
				$(loginPassword).val('');
				if(message !== '') {
					hideSpinner();
					if(message === 'timeout') {
                        window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, timeoutMessage);
						showErrorMessage(timeoutMessage);
					}else if(message === 'Internal Server Error'){
                        window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, generalMessage);
						showErrorMessage(generalMessage);
					}else{
                        window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, message);
						showErrorMessage(message);
					}
				} else {
                    window.ef.analyticsService.fireFormFailedEvent(loginFormType, loginFormName, loginFormLeadType, '');
                }
			});
	}
}

function checkSafariPrivateBrowsing() {
	try{
		// try to use localStorage
		localStorage.privacyCheck = 1;
	}catch(e) {
		showErrorMessage(privateBrowsing);
		$('#login-btn').attr('disabled', 'disabled');
	}
}

function removeRequestParam(paramString, paramName) {
    if (paramString.indexOf(paramName + '=') < 0) {
        return paramString;
    }
    let updatedQueryParamString = '';
    let isFirstParam = true;
    const queryParams = paramString.split('&');
    queryParams.forEach(queryParam => {
        const paramSeparator = isFirstParam ? '' : '&'
        if (!queryParam.startsWith(paramName + '=')) {
            updatedQueryParamString =  updatedQueryParamString + paramSeparator + queryParam;
            isFirstParam = false;
        }
    });
    return updatedQueryParamString;
}

$(() => {
	var mount = $(loginClass);

	if(mount.length) {
		window.ef.analyticsService.fireFormViewedEvent(loginFormType, loginFormName, loginFormLeadType);
		checkSafariPrivateBrowsing();
		$(loginBtn).attr('disabled', false);
		$(loginForm).submit(function(e) {
			if(e && typeof e.preventDefault === 'function') {
				e.preventDefault();
			}
			handleAuthRequest(this);
		});
	}

	if(!String.prototype.startsWith) {
		String.prototype.startsWith = function(searchString, position) { // eslint-disable-line no-extend-native
			position = position || 0;
			return this.indexOf(searchString, position) === position;
		};
	}
});
